module.exports = __webpack_public_path__ + "static/other/gameUniversity.7e3d3275.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameUniversity.json
// module id = 2273
// module chunks = 0